// Angular Files
import { Component } from '@angular/core';

// Component Files
import { TellerOnlineEngagementService } from './engagement.service';
import { TellerOnlineGuideOverlayComponent } from './guide-overlay.component';
import { TellerOnlineSurveyCardComponent } from './survey-card.component';

/** Place once at the root of each portal; renders nothing unless RUM is enabled. */
@Component({
    selector: 'teller-online-engagement-host',
    imports: [TellerOnlineGuideOverlayComponent, TellerOnlineSurveyCardComponent],
    templateUrl: './engagement-host.component.html'
})
export class TellerOnlineEngagementHostComponent {
    constructor(public engagementService: TellerOnlineEngagementService) { }
}
